// extracted by mini-css-extract-plugin
export default {"container":"RoomForms_container__PNhuV"};